import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    token: localStorage.getItem('token'),
    menu: '',
  },
  getters:{
    isLogin: state => state.isLogin,
    token: state => state.token,
  },
  mutations: {
    userStatus(state, value){
      state.isLogin = value.isLogin;
      state.token = value.token;
      localStorage.setItem('token', value.token);
    },
    menuStatus(state, value){
      state.menu = value;
      localStorage.setItem('menu', value);
    },
  },
  actions: {
    userLogin({commit},flag){
      commit("userStatus", flag)
    },
    menuGet({commit},params){
      commit("menuStatus", params)
    },
  },
  modules: {
  }
})
